import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ItemsService } from '../../../../services/items.service';
import { StockTransferService } from '../../../../services/stocktransferservice';

import { OrdersService } from '../../../../services/orders';
import { UserService } from '../../../../services/user';

@Component({
  selector: 'app-stocktransfer',
  templateUrl: './stocktransfer.component.html',
  styleUrl: './stocktransfer.component.scss'
})
export class StocktransferComponent implements OnInit {
  searchValue = '';

  form!: FormGroup;
  warehouses: any[] = [];
  stocks: any[] = [];
  contentReady = false;
  userId!: number;
  productsControl = this.fb.control([]);
  filteredStocks: any[] = [];
  submitted = false;
  constructor(
    private fb: FormBuilder,
    private stockTransferService: StockTransferService,
    private itemsService: ItemsService,
    private _userService: UserService,
    private router: Router,
    private _orderService: OrdersService,
  ) { }

  ngOnInit(): void {
    this.buildForm();
    this.loadWarehouses();
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.userId = data.user_id;
      }
    });
  }
  onSearchChange(event: any) {
    const value = event.target.value.toLowerCase();
    this.searchValue = value;

    this.filteredStocks = this.stocks.filter((p: any) =>
      p.name_ar.toLowerCase().includes(value) ||
      p.name_en?.toLowerCase().includes(value)
    );
  }
  addProduct(event: any) {

    const stock = event.option.value;

    this.addStockToItems(stock);

    this.searchValue = '';
  }

  toggleSelectAllProducts(): void {
    if (this.areAllAvailableProductsSelected()) {
      this.items.clear();
      return;
    }

    this.items.clear();
    this.getAvailableStocks().forEach((stock) => this.addStockToItems(stock));
  }

  clearSelectedProducts(): void {
    this.items.clear();
  }

  areAllAvailableProductsSelected(): boolean {
    const availableStocks = this.getAvailableStocks();

    return availableStocks.length > 0 &&
      availableStocks.every((stock) => this.isStockSelected(stock.id));
  }

  getAvailableStocksCount(): number {
    return this.getAvailableStocks().length;
  }

  private getAvailableStocks(): any[] {
    return this.stocks.filter((stock) => Number(stock?.quantity || 0) > 0);
  }

  private isStockSelected(stockId: any): boolean {
    return this.items.controls.some(
      c => String(c.value.stock_id) === String(stockId)
    );
  }

  private addStockToItems(stock: any): void {
    if (!stock || this.isStockSelected(stock.id)) return;

    this.items.push(
      this.fb.group({
        stock_id: [stock.id, Validators.required],
        quantity: [
          1,
          [
            Validators.required,
            Validators.min(1),
            Validators.max(stock.quantity)
          ]
        ],
        product: [stock]
      })
    );
  }
  filterStocks(event: any) {
    const value = event.target.value.toLowerCase();
    this.filteredStocks = this.stocks.filter((p: any) =>
      p.name_ar.toLowerCase().includes(value)
    );
  }
  onStockSelected(selectedStocks: any[]) {

    const selectedIds = selectedStocks.map(s => s.id);

    /** 🧹 1) احذف من الجدول أي منتج اتشال من dropdown */
    for (let i = this.items.length - 1; i >= 0; i--) {
      const item = this.items.at(i).value;
      if (!selectedIds.includes(item.stock_id)) {
        this.items.removeAt(i);
      }
    }

    /** ➕ 2) أضف الجديد */
    selectedStocks.forEach(stock => {

      const exists = this.items.controls.some(
        c => c.value.stock_id === stock.id
      );
      if (exists) return;

      this.items.push(
        this.fb.group({
          stock_id: [stock.id, Validators.required],
          quantity: [
            1,
            [
              Validators.required,
              Validators.min(1),
              Validators.max(stock.quantity)
            ]
          ],
          product: [stock] // للعرض فقط
        })
      );
    });
  }


  buildForm() {
    this.form = this.fb.group({
      from_warehouse_id: ['', Validators.required],
      to_warehouse_id: ['', Validators.required],
      notes: [''],
      items: this.fb.array([])
    });
  }

  shouldShowError(controlName: string): boolean {
    const control = this.form?.get(controlName);
    return !!control && control.invalid && (control.touched || this.submitted);
  }

  shouldShowSameWarehouseError(): boolean {
    return this.submitted && !!this.form?.value.from_warehouse_id &&
      this.form.value.from_warehouse_id === this.form.value.to_warehouse_id;
  }

  shouldShowItemsError(): boolean {
    return this.submitted && this.items.length === 0;
  }

  shouldShowQuantityError(index: number): boolean {
    const control = this.items.at(index)?.get('quantity');
    return !!control && control.invalid && (control.touched || this.submitted);
  }

  getErrorMessage(controlName: string, label: string): string {
    const control = this.form?.get(controlName);

    if (control?.errors?.['required']) {
      return `${label} مطلوب`;
    }

    return `${label} غير صحيح`;
  }

  getQuantityErrorMessage(index: number): string {
    const control = this.items.at(index)?.get('quantity');
    const available = this.items.at(index)?.value.product.quantity;

    if (control?.errors?.['required']) {
      return 'الكمية مطلوبة';
    }

    if (control?.errors?.['min']) {
      return 'الكمية لازم تكون 1 على الأقل';
    }

    if (control?.errors?.['max']) {
      return `الكمية أكبر من المتاح (${available})`;
    }

    return 'الكمية غير صحيحة';
  }

  getMissingRequiredCount(): number {
    let count = 0;

    if (this.form) {
      if (this.form.get('from_warehouse_id')?.hasError('required')) count++;
      if (this.form.get('to_warehouse_id')?.hasError('required')) count++;
    }

    if (this.shouldShowSameWarehouseError()) count++;
    if (this.items.length === 0) count++;

    count += this.items.controls.filter((item) => item.get('quantity')?.invalid).length;

    return count;
  }

  private validateBeforePreview(): boolean {
    this.submitted = true;
    this.form.markAllAsTouched();
    this.items.controls.forEach((item) => item.markAllAsTouched());

    const toWarehouseControl = this.form.get('to_warehouse_id');
    if (this.form.value.from_warehouse_id && this.form.value.from_warehouse_id === this.form.value.to_warehouse_id) {
      toWarehouseControl?.setErrors({ ...(toWarehouseControl.errors || {}), sameWarehouse: true });
    } else if (toWarehouseControl?.hasError('sameWarehouse')) {
      const errors = { ...(toWarehouseControl.errors || {}) };
      delete errors['sameWarehouse'];
      toWarehouseControl.setErrors(Object.keys(errors).length ? errors : null);
    }

    if (this.form.invalid || this.items.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'تأكد من بيانات التحويل',
        text: 'راجع الرسائل تحت الحقول المطلوبة أو غير الصحيحة',
        confirmButtonText: 'تمام'
      });

      return false;
    }

    return true;
  }

  // 🔁 FormArray
  get items(): FormArray {
    return this.form.get('items') as FormArray;
  }

  // ➕ إضافة منتج
  // ➕ إضافة منتج
  addItem(stock: any) {
    if (!stock) return;

    // ❌ منع تكرار نفس المنتج
    const exists = this.items.controls.some(
      c => c.value.stock_id === stock.id
    );
    if (exists) {
      Swal.fire('تنبيه', 'المنتج مضاف بالفعل', 'warning');
      return;
    }

    this.items.push(
      this.fb.group({
        stock_id: [stock.id, Validators.required],
        quantity: [
          1,
          [
            Validators.required,
            Validators.min(1),
            Validators.max(stock.quantity) // ✅ يمنع كمية أكبر من المتاح
          ]
        ],
        product: [stock] // للعرض فقط
      })
    );
  }
  onQuantityChange(index: number) {
    const item = this.items.at(index);
    const qty = item.get('quantity')?.value || 0;
    const available = item.value.product.quantity;

    // ⚠️ Warning لو أكتر من 70%
    if (qty >= available * 0.7) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        title: '⚠️ كمية كبيرة من المخزون',
        text: 'أنت على وشك نقل أكثر من 70% من المخزون',
        showConfirmButton: false,
        timer: 2500
      });
    }
  }

  getRemainingQty(index: number): number {
    const item = this.items.at(index).value;
    return item.product.quantity - item.quantity;
  }
  applyQuickNote(event: any) {
    const note = event.target.value;
    if (!note) return;

    this.form.patchValue({
      notes: note
    });
  }
  openPreview() {
    if (!this.validateBeforePreview()) {
      return;
    }

    if (this.form.invalid || this.items.length === 0) {
      Swal.fire('تنبيه', 'تأكد من البيانات والمنتجات', 'warning');
      return;
    }

    const fromWarehouse = this.warehouses.find(
      w => w.id == this.form.value.from_warehouse_id
    )?.name;

    const toWarehouse = this.warehouses.find(
      w => w.id == this.form.value.to_warehouse_id
    )?.name;

    const totalQty = this.items.controls.reduce(
      (sum, i) => sum + Number(i.value.quantity),
      0
    );

    Swal.fire({
      title: '📦 تأكيد التحويل',
      html: `
      <b>من:</b> ${fromWarehouse}<br>
      <b>إلى:</b> ${toWarehouse}<br><br>

      <b>عدد المنتجات:</b> ${this.items.length}<br>
      <b>إجمالي الكمية:</b> ${totalQty}<br><br>

      <b>المستخدم:</b> ${this.userId}
    `,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: '✔️ تأكيد',
      cancelButtonText: '❌ رجوع'
    }).then(result => {
      if (result.isConfirmed) {
        this.onSubmit();
      }
    });
  }


  // ❌ حذف منتج
  removeItem(index: number) {
    this.items.removeAt(index);
  }

  // 🏬 Warehouses dropdown (زي register)
  loadWarehouses() {
    this.itemsService.getWearHouses().subscribe(res => {
      this.warehouses = res.warehouse;
    });
  }

  // 📦 تحميل منتجات المخزن المصدر
  loadStocks() {
    const fromWarehouse = this.form.value.from_warehouse_id;
    if (!fromWarehouse) return;

    this._orderService.getStocksData(fromWarehouse).subscribe(res => {
      this.stocks = res.stocks;
      this.filteredStocks = res.stocks;
      this.searchValue = '';
      this.items.clear();
    });
  }


  // 🚀 Submit
  onSubmit() {
    this.contentReady = true;

    const payload = {
      ...this.form.value,
      user_id: this.userId,
      items: this.form.value.items.map((i: any) => ({
        stock_id: i.stock_id,
        quantity: i.quantity
      }))
    };

    this.stockTransferService.createTransfer(payload).subscribe({
      next: () => {
        Swal.fire('تم', 'تم تحويل المخزون بنجاح', 'success');
        this.form.reset();
        this.items.clear();
        this.contentReady = false;
        this.router.navigateByUrl('/StocktransferHistory');
      },
      error: () => {
        Swal.fire('خطأ', 'فشل تحويل المخزون', 'error');
        this.contentReady = false;
      }
    });
  }

}
